import { render, staticRenderFns } from "./gcePersistentDisk.vue?vue&type=template&id=efabcaa4&"
import script from "./gcePersistentDisk.vue?vue&type=script&lang=js&"
export * from "./gcePersistentDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports